import * as E from 'fp-ts/Eq';
import { Message } from '../services/buildfire/rdb/messages';

export const messageIsEqual: E.Eq<Message> = {
  equals: (x, y) => x.id === y.id,
};
